import { useState } from "react";
import JsonLd from "@/components/common/JsonLd";
import SectionHeader from "@/components/common/SectionHeader";

const faqs = [
  {
    q: "91漫画上的漫画可以免费阅读吗？",
    a: "是的，91漫画提供海量免费漫画在线阅读，无需付费即可随时畅读热血、恋爱、奇幻、悬疑等多种分类的热门作品。",
  },
  {
    q: "如何快速找到想看的漫画？",
    a: "你可以通过顶部分类浏览按类型查找，也可以直接使用搜索框输入漫画名称关键词，或者查看人气榜、完结榜和新作榜单快速定位。",
  },
  {
    q: "漫画的更新频率是怎样的？",
    a: "连载中的热门漫画会每日更新，新作会第一时间上架，完结作品则完整收录，确保读者不错过任何一话。",
  },
  {
    q: "哪些分类的漫画最受欢迎？",
    a: "热血、恋爱、奇幻、悬疑是当前最受欢迎的分类，你可以进入对应分类页查看该类型下的人气排行与热门推荐。",
  },
];

export default function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="mx-auto px-4 md:px-6 max-w-4xl">
        <SectionHeader title="常见问题" subtitle="关于91漫画，你想知道的都在这里" icon="ri-question-line" />
        <JsonLd
          data={{
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: faqs.map((f) => ({
              "@type": "Question",
              name: f.q,
              acceptedAnswer: { "@type": "Answer", text: f.a },
            })),
          }}
        />
        <div className="space-y-3">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <div key={i} className="rounded-lg border border-background-200/70 bg-background-100 overflow-hidden">
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? null : i)}
                  className="w-full flex items-center justify-between gap-3 px-4 py-3.5 text-left text-sm font-semibold text-foreground-900 hover:bg-background-50 cursor-pointer"
                  aria-expanded={isOpen}
                >
                  <span>{f.q}</span>
                  <i className={`ri-arrow-down-s-line text-lg text-primary-500 transition-transform ${isOpen ? "rotate-180" : ""}`}></i>
                </button>
                {isOpen && <p className="px-4 pb-4 text-sm leading-relaxed text-foreground-600">{f.a}</p>}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}